import { registry } from '@cian/mf-registry/browser';

const HEADER_MICROFRONTEND_NAME = 'header-frontend';

/**
 * Гарантирует, что API-рантайм микрофронтенда шапки загружен и готов к вызовам.
 */
export async function ensureHeaderMicrofrontend() {
  return registry().microfrontendStrict(HEADER_MICROFRONTEND_NAME).api()?.ensure();
}
